import { FC } from 'react';

interface ColorPickerProps {
  label?: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

export const ColorPicker: FC<ColorPickerProps> = ({
  label,
  value,
  onChange,
  placeholder = '#000000',
  className = '',
}) => {
  return (
    <div className={`space-y-1.5 ${className}`}>
      {label && (
        <label className="block text-xs font-medium text-slate-600 mb-1.5 capitalize">
          {label}
        </label>
      )}
      <div className="flex gap-2">
        <input
          type="color"
          value={value || '#000000'}
          onChange={(e) => onChange(e.target.value)}
          className="h-9 w-11 rounded-lg border border-slate-200 cursor-pointer"
        />
        <input
          type="text"
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          className="flex-1 h-9 px-2.5 text-xs text-slate-900 border border-slate-200 rounded-lg 
            focus:outline-none focus:ring-2 focus:ring-slate-900/10 focus:border-slate-400"
        />
      </div>
    </div>
  );
};

